import { Flex, Alert } from "antd";
import CancelButton from "../CustomButton/CancelButton";
import PrimaryButton from "../CustomButton/PrimaryButton";
import "./CustomForms.scss";

const FormFooter = ({
  onCancelClick,
  submitLoading,
  btnName,
  disabled,
  error,
}) => {
  return (
    <Flex gap={10} justify="space-between" className="form-footer-container">
      <div>{error && <Alert message={error} type="error" showIcon />}</div>
      <Flex gap={10}>
        <CancelButton onClick={onCancelClick} />
        <PrimaryButton
          disabled={disabled}
          loading={submitLoading}
          htmlType="submit"
        >
          {btnName}
        </PrimaryButton>
      </Flex>
    </Flex>
  );
};

export default FormFooter;
